import { RoleTemplate } from '@cims-online/shared'
import CIMSTable from 'components/CIMSTable'
import { useColumns } from './hooks/useColumns'

const TemplatesTable: React.VFC = () => {
  return (
    <CIMSTable
      rowKey={'id'}
      records={RoleTemplate.values}
      columns={useColumns()}
    />
  )
}

export default TemplatesTable
